import {
  CheckCircleOutlined,
  CloseCircleFilled,
  CloseCircleOutlined,
  LoadingOutlined,
} from '@ant-design/icons'
import { Button, Modal } from 'antd'
import React from 'react'
import { withHandlers, withState } from 'recompose'
import { compose } from 'redux'

import { withFeedback } from '../higher-order/feedback'
import './SaveErrorModal.css'

type SaveErrorModalProps = {
  retrying: boolean
  feedback: string
  doRetry(): void
}

const SaveEntryModal = ({ retrying, feedback, doRetry }: SaveErrorModalProps) => (
  <Modal
    visible
    title={
      <span className="error-modal-title">
        <CloseCircleFilled /> Connection Problems
      </span>
    }
    closable={false}
    footer={
      <Button
        key="retry"
        type="primary"
        onClick={doRetry}
        disabled={retrying}
        className={`feedback-${feedback}`}>
        {feedback === 'none' && 'Retry'}
        {retrying && <LoadingOutlined />}
        {feedback === 'error' && (
          <React.Fragment>
            Failure <CloseCircleOutlined />
          </React.Fragment>
        )}
        {feedback === 'success' && (
          <React.Fragment>
            Success <CheckCircleOutlined />
          </React.Fragment>
        )}
      </Button>
    }>
    Make sure the phone is connected to network and retry. If problems persist, please contact an
    organizer.
  </Modal>
)

export default compose<any>(
  withState('retrying', 'setRetrying', false),
  withFeedback(1200),
  withHandlers({
    doRetry: ({ retry, hide, setRetrying, showFeedback }) => () => {
      setRetrying(true)
      retry()
        .then(() => {
          setRetrying(false)
          showFeedback('success').then(hide)
        })
        .catch(() => {
          setRetrying(false)
          showFeedback('error')
        })
    },
  }),
)(SaveEntryModal)



// WEBPACK FOOTER //
// ./src/components/mobile/SaveErrorModal.tsx